export const GET_ALL_EXPENSES = `
    query GetAllExpenses($input: ExpensesInput!, $skip: Float!, $take: Float!){
        getAllExpenses(input: $input, skip: $skip, take: $take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                startDate
                expensesType
                policyExpenses
                actualExpenses
                numberPerson
                finalExpenses
                note
                texpensesType{
                    id
                    name
                    expensesAmount
                    tunit{
                        id
                        name
                    }
                }
                tuser{
                    jobTitle
                    employeeId
                    fullName
                }
                troute{
                    id
                    name
                }
                tteamSales{
                    id
                    subId
                    name
                    plantId
                }
                tcustomer{
                    id
                    sapCustomerId
                    storeName
                }
                createDate
                tcreateUser{
                    id
                    fullName
                }
                modifyDate
                tmodifyUser{
                    id
                    fullName
                }
            }
        }
    }
`;

export const GET_SUM_EXPENSES = `
    query GetAllExpenses($input: ExpensesInput!){
        getSumExpenses(input: $input){
        code
        success
        message
        data{
            actualExpenses
            policyExpenses
            finalExpenses
        }
        }
    }
`;

export const GET_ALL_EMPLOYEES = `
    query GetAllExpenses($input: TuserWhereInput!, $skip: Float!, $take: Float!){
        getUser(where: $input, skip: $skip, take: $take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                fullName
                employeeId
            }
        }
    }
`;

export const GET_ALL_EXPENSE_TYPES = `
    query GetAllExpenses($input: TexpensesTypeWhereInput!, $skip: Float!, $take: Float!){
        getExpensesType(where: $input, skip: $skip, take: $take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                name
                expensesAmount
                tunit{
                    id
                    name
                }
            }
        }
    }
`;

export const CREATE_EXPENSE = `
    mutation CreateExpenses($input: TexpensesInput!){
        createExpenses(input: $input){
            id
            startDate
            customerId
            teamSalesId
            routeId
            userId
            expensesType
            policyExpenses
            actualExpenses
            numberPerson
            finalExpenses
            note
        }
    }
`;

export const UPDATE_EXPENSE = `
    mutation CreateExpenses($input: TexpensesInput!){
        updateExpenses(input: $input){
            id
            startDate
            customerId
            teamSalesId
            routeId
            userId
            expensesType
            policyExpenses
            actualExpenses
            numberPerson
            finalExpenses
            note
        }
    }
`;

export const GET_ROUTES = `
    query GetAllSalePlanning(
        $input: GetSalesPlanningListInput
        $skip: Float
        $take: Float
    ) {
        getSalesPlanningList(where: $input, skip: $skip, take: $take) {
        pageInfo {
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items {
            routeId
            routeName
        }
    }
}
`;
